export const TRACK_LIST_BREADCRUMB_TEST_ID = 'TrackListButton';
export const TRACK_LIST_BREADCRUMB_LOADING_TEST_ID = 'TrackListButtonLoadingState';
